export enum DropdownDirection {
  Top = "Top",
  Right = "Right",
  Bottom = "Bottom",
  Left = "Left"
}
